// Single source of truth for the MIME types accepted by the UGC files dropzone
// and the filetype -> preview-icon URL mapping. Mirrors ContentAttachment::FileTypes
// in Pony.

export const PREVIEW_URL_BASE =
  'https://lib.onfirstup.com/content_blocks/attachments';

const CANONICAL_FILETYPES = new Set(['pdf', 'doc', 'xls', 'ppt', 'ics']);

const MIME_TO_FILETYPE: Record<string, string> = {
  'application/pdf': 'pdf',
  // Word
  'application/msword': 'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
    'doc',
  'application/vnd.ms-word.document.macroEnabled.12': 'doc',
  'application/vnd.ms-word.template.macroEnabled.12': 'doc',
  // Excel
  'application/vnd.ms-excel': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': 'xls',
  'application/vnd.ms-excel.sheet.macroEnabled.12': 'xls',
  'application/vnd.ms-excel.template.macroEnabled.12': 'xls',
  'application/vnd.ms-excel.addin.macroEnabled.12': 'xls',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12': 'xls',
  // PowerPoint
  'application/vnd.ms-powerpoint': 'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.template':
    'ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
    'ppt',
  'application/vnd.ms-powerpoint.addin.macroEnabled.12': 'ppt',
  'application/vnd.ms-powerpoint.presentation.macroEnabled.12': 'ppt',
  'application/vnd.ms-powerpoint.template.macroEnabled.12': 'ppt',
  'application/vnd.ms-powerpoint.slideshow.macroEnabled.12': 'ppt',
  // Calendar
  'text/calendar': 'ics',
};

export const ACCEPTED_MIME_TYPES = Object.keys(MIME_TO_FILETYPE);

export function canonicalFiletype(
  input: string | undefined
): string | undefined {
  if (!input) return undefined;
  if (CANONICAL_FILETYPES.has(input)) return input;
  return MIME_TO_FILETYPE[input];
}

export function getPreviewUrl(input: string | undefined): string | undefined {
  const filetype = canonicalFiletype(input);
  return filetype ? `${PREVIEW_URL_BASE}/${filetype}-icon.svg` : undefined;
}
